import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CintraCloudLogoComponent } from '@app/app-layout/cintra-cloud-logo/cintra-cloud-logo.component';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CintraCloudLogoComponent]
})
export class AuthLayoutComponent {}
